import React, { Component } from 'react';
import ErrorReportingTool from '../../common/config/ErrorReportingTool';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      errorInfo: {}
    };
  }

  componentDidCatch(error, info) {
    this.setState({
      hasError: true,
      errorInfo: info
    });   
    ErrorReportingTool.reportReactLifeCycle(info, error.stack);    
  }

  render() {
    if(this.state.hasError){      
      return <div>{this.state.errorInfo}</div>
    }
    return this.props.children;
  }
}

export default ErrorBoundary


// WEBPACK FOOTER //
// ./src/app/common/boundary/index.js